import React, { Fragment, PureComponent } from 'react';
import Parser from 'html-react-parser';
import { NavLink } from 'react-router-dom';
import { AJAX_PUBLIC_REQUEST, SET_STORAGE, GET_STORAGE, REMOVE_STORAGE, CHECK_STORAGE, CURRENCY_FORMAT, BUNDLE_SUB_TOTAL, BUNDLE_OFFER_NEW, ITEM_COUNT } from '../../Constants/AppConstants';
import SingleCustomProductListGrid from './SingleCustomProductListGrid';
import SingleProductModal from './SingleProductModal';
import Pagination from '../Common/Pagination';
import SingleProductNotAvailableModal from './SingleProductNotAvailableModal';
import SingleProductNotAvailable from './SingleProductNotAvailable'
import SearchIcon from './../../Assets/images/customer_images/header_search.svg'
import HomeIcon from './../../Assets/images/refer_images/home_icon.svg'
import UploadIcon from './../../Assets/images/refer_images/upload_product_icon.svg'
import { Row, Col } from "react-bootstrap";
import AddedCustomProductsList from "./AddedCustomProductsList";
import DeleteIcon from '../../Assets/images/refer_images/bundle-delete.svg';
import ReactImageFallback from "react-image-fallback";
import classnames from 'classnames';
import $ from 'jquery';
import history from "../../history";

class CreateCustomBundleByPrice extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            products: [],
            productDetails: {},
            product_filter: [],
            products_filtered: [],
            filter_by: 'popular',
            listView: false,
            ProductLink: '',
            productNotAvailable: ["Bulletproof Vitality For Her", "Women's Ultimate", "Women's Immune Booster"],
            // productNotAvailable:[],
            // Pagination Config
            item_count: 0,
            total_records: 0,
            total_page: 0,
            per_page: 0,
            pagenum: 1,
            searchName: '',
            cartLink: '/cart',
            AddedProducts: [],
            custom_bundle_discount_settings: GET_STORAGE('custom_bundle_discount_settings') || 'disable',
            order_amount_discount: [],
            discount_data: (GET_STORAGE("Discount_data")) ? JSON.parse(GET_STORAGE("Discount_data")) : '',
            subscription_detail: '',
            subscription: GET_STORAGE('is_subscription') ? GET_STORAGE('is_subscription') : 'no',
            NotallowedtoSubscription: false,
        }
        document.title = "Create Custom Bundle - Prestige Labs";
    }

    componentDidMount() {
        document.querySelector("body").scrollIntoView();
        document.body.classList.remove('home_page');
        this.getProducts(this.state.filter_by, this.state.pagenum);
        this.getCart();
        REMOVE_STORAGE("Discount_data");
    }

    getProducts = (filterBy, pageNumber) => {
        let data = {
            filter_by: filterBy
        }
        AJAX_PUBLIC_REQUEST("POST", "product/getCustomBundleList", data).then(results => {
            if (results.response.code === 1000) {
                // normalize enable/disable flag from api
                let rawSetting = results.response.custom_bundle_discount_settings;
                let normalizedSetting = 'disable';
                if (typeof rawSetting === 'string') {
                    const v = rawSetting.toLowerCase();
                    if (v === 'enable' || v === 'enabled' || v === 'yes' || v === 'true' || v === '1') {
                        normalizedSetting = 'enable';
                    }
                } else if (rawSetting === 1 || rawSetting === true) {
                    normalizedSetting = 'enable';
                }

                // Redirect to appropriate URL based on setting
                if (normalizedSetting === 'disable') {
                    history.push('/create-custom-bundle');
                    return;
                }

                this.setState({
                    product_filter: results.response.data,
                    products: results.response.data,
                    products_filtered: results.response.data,
                    loading: false,
                    // Pagination Config
                    item_count: parseInt(results.response.data.length),
                    total_records: parseInt(results.response.total_records),
                    order_amount_discount: results.response.order_amount_discount || [],
                    custom_bundle_discount_settings: normalizedSetting,
                    subscription_detail: results.response.subscription_detail,
                });

                if (results.response.order_amount_discount) {
                    SET_STORAGE('orderAmountDiscount', JSON.stringify(results.response.order_amount_discount));
                }
                SET_STORAGE('custom_bundle_discount_settings', normalizedSetting);
                SET_STORAGE('CustomSubscriptionDetail', JSON.stringify(results.response.subscription_detail));
            } else {
                this.setState({ loading: false, error: Parser("<p className='text-danger'>" + results.response.message + "</p>") });
            }
        });
    }

    pagenationHandle = (pageNumber) => {
        this.setState({ loading: true });
        this.getProducts(this.state.filter_by, pageNumber);
    }

    gridListView = (e) => {
        this.setState({ listView: !this.state.listView });
    }

    handleCart = (e) => {
        SET_STORAGE('amount_bundle_flow', 'yes');
        SET_STORAGE('Discount_data', JSON.stringify([]));
        history.push("/cart");
    }

    filterBy = (e) => {
        let filter_by = e.target.value;
        this.setState({
            loading: true,
            [e.target.name]: filter_by
        })
        this.getProducts(filter_by, 1);
    }

    filterProduct = (e) => {
        const val = e.target.value;
        this.setState({
            searchName: val,
            products_filtered: this.state.product_filter.filter(function (product) {
                if (val === '') { return product; }
                let string = product.title.toUpperCase();
                let substring = val.toUpperCase();
                if (string.includes(substring)) { return product; }
            }.bind(this))
        });
    }

    alertModel = () => {
        if (ITEM_COUNT() != 0) {
            $(`#${'alertModel'}`).modal({ backdrop: 'static', keyboard: false });
        } else {
            // Mark that this bundle comes from amount-based page so cart can suppress quantity offers
            SET_STORAGE('amount_bundle_flow', 'yes');
            // Clear any quantity-discount data so /cart doesn't compute % off or per-item discounts
            SET_STORAGE('Discount_data', JSON.stringify([]));
            history.push("/cart");
        }
    }

	getCart = () => {
		const discountDataFromStorage = GET_STORAGE("Discount_data");
		let discount_data_new = discountDataFromStorage ? JSON.parse(discountDataFromStorage) : '';
		this.setState({ discount_data: discount_data_new });
		const bundleDataFromStorage = GET_STORAGE("Bundle");
		if (!bundleDataFromStorage) {
			this.setState({ AddedProducts: [] });
			SET_STORAGE("Bundle", []);
			SET_STORAGE("BundleCart", []);
			return;
		}
		const products = JSON.parse(bundleDataFromStorage);
		const discountApplied = this.state.discount_data === discount_data_new;
		const updateProductsWithDiscount = (products, discount_data) => {
			return products.map((product, index) => {
				const Inddiscount = discount_data[index];
				const newSalePrice = product.cart_sale_price - Inddiscount;
				return {
					...product,
					custom_bundle_discount_price: newSalePrice.toFixed(2),
					custom_bundle_discount: Inddiscount.toFixed(2)
				};
			});
		};
		let updatedProducts = products;

		if (discount_data_new.length > 0 && !discountApplied) {
			updatedProducts = updateProductsWithDiscount(products, discount_data_new);
			this.setState({
				AddedProducts: updatedProducts,
				discount_data: discount_data_new
			});
			SET_STORAGE("Bundle", JSON.stringify(updatedProducts));
		} else {
			this.setState({ AddedProducts: products, discount_data: discount_data_new });
		}
		const hasSubscriptionStatusZero = products.some(product => product.subscription_status == "0" || product.subscription_status == null);
		this.setState({ NotallowedtoSubscription: hasSubscriptionStatusZero ? true : false });
		if (GET_STORAGE('is_subscription') == "yes") {
			let bundle = JSON.parse(GET_STORAGE("Bundle"));
			let subscription_detail = JSON.parse(GET_STORAGE("CustomSubscriptionDetail"));
			const subscriptionSavePercentage = parseFloat(subscription_detail.subscription_save_percentage_refer);
			const discountFactor = subscriptionSavePercentage / 100;

			updatedProducts = bundle.map(product => {
				// Apply subscription discount to original price, not to already discounted price
				const originalPrice = parseFloat(product.cart_sale_price);
				const discountedPrice = originalPrice * (1 - discountFactor);
				return {
					...product,
					custom_bundle_discount_price: discountedPrice.toFixed(2),
					custom_bundle_discount: (originalPrice - discountedPrice).toFixed(2)
				};
			});

			this.setState({ AddedProducts: updatedProducts });
			SET_STORAGE("Bundle", JSON.stringify(updatedProducts));
		} else {
			// When subscription is disabled, reset prices to original values
			let bundle = JSON.parse(GET_STORAGE("Bundle"));
			if (bundle && bundle.length > 0) {
				const resetBundle = bundle.map(product => ({
					...product,
					custom_bundle_discount_price: parseFloat(product.cart_sale_price).toFixed(2),
					custom_bundle_discount: 0
				}));
				this.setState({ AddedProducts: resetBundle });
				SET_STORAGE("Bundle", JSON.stringify(resetBundle));
			}
		}
	};

    // Helpers similar to public page for sidebar list
    getFlavorLabel = (product) => {
        if (!product) return '';
        if (product.cart_variation_name && String(product.cart_variation_name).trim() !== '') {
            return product.cart_variation_name;
        }
        if (product.activeFlavors && product.cart_flavor_id) {
            const match = product.activeFlavors.find(f => String(f.id) === String(product.cart_flavor_id));
            if (match && match.value) return match.value;
        }
        if (product.productInfo && product.productInfo.variations && product.cart_variation_id) {
            const variations = product.productInfo.variations;
            const keys = Object.keys(variations || {});
            for (let i = 0; i < keys.length; i++) {
                const v = variations[keys[i]];
                if (v && String(v.variation_id) === String(product.cart_variation_id) && v.variation_name) {
                    return v.variation_name;
                }
            }
        }
        return '';
    }

    getFlavorOptions = (product) => {
        if (!product) return [];
        if (Array.isArray(product.activeFlavors) && product.activeFlavors.length > 0) {
            return product.activeFlavors.filter(f => f && (f.id || f.value));
        }
        if (product.productInfo) {
            const pi = product.productInfo;
            if (Array.isArray(pi.activeFlavors) && pi.activeFlavors.length > 0) return pi.activeFlavors;
            if (Array.isArray(pi.flavors) && pi.flavors.length > 0) return pi.flavors;
            if (pi.variations && typeof pi.variations === 'object') {
                const out = [];
                Object.keys(pi.variations).forEach(k => {
                    const v = pi.variations[k];
                    if (!v) return;
                    const parts = String(k).split('_');
                    if (parts.length >= 2) {
                        const id = parts[1];
                        const value = v.variation_name || v.variation || v.name || id;
                        out.push({ id, value });
                    }
                });
                return out;
            }
        }
        return [];
    }

    // Change flavors in sidebar (amount-based bundle)
    changeFirstMonthFlovour = (product, productInfo, activeFlavors, flavorId) => {
        const variationKey = "1_" + flavorId;
        const newVar = productInfo.variations ? productInfo.variations[variationKey] : null;
    
        if (this.state.subscription === "yes" && newVar && (newVar.subscription_status === "0" || !newVar.subscription_status)) {
            this.isSubscription(); 
        }
    
        this.removeFlavorFromBundle(product.cart_variation_id);
        this.setState({ firstMonthflavorId: flavorId }, () => {
            this.variation(variationKey, activeFlavors, productInfo);
        });
    };

    removeFlavorFromBundle = (variationId) => {
        let bundle = JSON.parse(GET_STORAGE("Bundle")) || [];
        bundle = bundle.filter(item => String(item.cart_variation_id) !== String(variationId));
        SET_STORAGE("Bundle", JSON.stringify(bundle));
        this.updateAddedProducts(JSON.stringify(bundle));
    };

    variation = (variationKey, activeFlavors, productInfo) => {
        const product = productInfo;
        const variation = product && product.variations ? product.variations[variationKey] : null;

        let regular_price = 0;
        let sale_price = 0;
        if (variation) {
            if (parseFloat(variation.sale_price) > 0) {
                regular_price = variation.regular_price;
                sale_price = variation.sale_price;
            } else {
                regular_price = variation.regular_price;
                sale_price = variation.regular_price;
            }
        }

        // Add the newly selected variant back to bundle
        this.addToBundle({
            cart_product_id: product.product_id,
            cart_product_name: product.title,
            cart_product_sku: variation ? variation.sku : '',
            cart_product_description: product.short_description,
            cart_product_isbundle: product.is_bundle,
            cart_product_weight_lb: 0.0,
            cart_product_slug: product.slug,
            cart_image: product.thumb_image,
            cart_variation_id: variation ? variation.variation_id : '',
            cart_flavor_id: this.state.firstMonthflavorId,
            cart_variation_name: variation ? variation.variation_name : '',
            cart_sale_price: sale_price,
            subscription: null,
            cart_discount_price: sale_price - (sale_price * product.subscription_save_percentage) / 100,
            quantity: 1,
            in_stock: variation ? parseInt(variation.quantity, 10) : 0,
            regular_price: regular_price,
            subscription_status: variation ? variation.subscription_status : null,
            activeFlavors: activeFlavors,
            productInfo: productInfo
        });
    }

    addToBundle = (event) => {
        let bundle = JSON.parse(GET_STORAGE("Bundle")) || [];

        const newItem = {
            cart_product_id: event.cart_product_id,
            cart_product_name: event.cart_product_name,
            cart_product_sku: event.cart_product_sku,
            cart_product_description: event.cart_product_description,
            cart_product_isbundle: event.cart_product_isbundle,
            cart_product_weight_lb: event.cart_product_weight_lb,
            cart_product_slug: event.cart_product_slug,
            cart_image: event.cart_image,
            cart_variation_id: event.cart_variation_id,
            cart_flavor_id: event.cart_flavor_id,
            cart_variation_name: event.cart_variation_name,
            cart_sale_price: parseFloat(event.cart_sale_price),
            subscription: event.subscription,
            cart_subscription_msg: event.cart_subscription_msg,
            cart_discount_price: parseFloat(event.cart_discount_price),
            quantity: parseInt(event.quantity, 10),
            in_stock: parseInt(event.in_stock, 10),
            regular_price: parseFloat(event.regular_price),
            custom_bundle_discount_price: parseFloat(event.cart_sale_price),
            custom_bundle_discount: 0,
            subscription_status: event.subscription_status,
            activeFlavors: event.activeFlavors,
            productInfo: event.productInfo
        };

        let data = [];
        let isItemAdded = false;

        bundle.forEach((item) => {
            if (String(item.cart_variation_id) === String(newItem.cart_variation_id)) {
                if (parseInt(item.quantity, 10) >= parseInt(newItem.in_stock, 10)) {
                    alert("Out Of Stock");
                } else {
                    item.quantity += newItem.quantity;
                }
                isItemAdded = true;
            }
            data.push(item);
        });

        if (!isItemAdded) {
            data.push(newItem);
        }

        SET_STORAGE("Bundle", JSON.stringify(data));
        setTimeout(() => {
            this.updateAddedProducts(JSON.stringify(data));
        }, 300);
        this.getCart();
    }

    updateBundleQuantity = (cart_variation_id, updatedQuantity) => {
        let bundle = JSON.parse(GET_STORAGE("Bundle")) || [];
        bundle = bundle.map((item) => {
            if (String(item.cart_variation_id) === String(cart_variation_id)) {
                return { ...item, quantity: updatedQuantity };
            }
            return item;
        });
        SET_STORAGE("Bundle", JSON.stringify(bundle));
        this.updateAddedProducts(JSON.stringify(bundle));
    }

    quantityIncrement = (cart_variation_id, quantity) => {
        const updatedQuantity = (parseInt(quantity, 10) || 0) + 1;
        this.updateBundleQuantity(cart_variation_id, updatedQuantity);
    };

    isSubscription = (e) => {
        // Toggle subscription state
        const newSubscriptionState = this.state.subscription === "yes" ? "no" : "yes";
        
        // Update storage and state
        SET_STORAGE("is_subscription", newSubscriptionState);
        this.setState({ subscription: newSubscriptionState }, () => {
            // Reload the cart with the new subscription state
            this.getCart();
            
            // If enabling subscription, apply the discount once
            if (newSubscriptionState === "yes") {
                const bundle = JSON.parse(GET_STORAGE("Bundle") || '[]');
                if (bundle && bundle.length > 0) {
                    this.updateAddedProducts(JSON.stringify(bundle));
                }
            } else {
                // If disabling subscription, reset prices to original
                const bundle = JSON.parse(GET_STORAGE("Bundle") || '[]');
                if (bundle && bundle.length > 0) {
                    const resetBundle = bundle.map(item => ({
                        ...item,
                        custom_bundle_discount_price: parseFloat(item.cart_sale_price).toFixed(2),
                        custom_bundle_discount: 0
                    }));
                    SET_STORAGE("Bundle", JSON.stringify(resetBundle));
                    this.setState({ AddedProducts: resetBundle });
                }
            }
        });
    };
    
    quantityDecrement = (cart_variation_id, quantity) => {
        const q = parseInt(quantity, 10) || 0;
        if (q > 1) {
            this.updateBundleQuantity(cart_variation_id, q - 1);
        }
    };

    deleteItem = (e, row_id) => {
        e.preventDefault();
        if (window.confirm("Are you sure you want to delete the item?")) {
            let cart = JSON.parse(GET_STORAGE("Bundle")) || [];
            if (cart.splice(row_id, 1)) {
                this.setState({
                    success_alert_wrapper_show: true,
                    server_message: "Item removed from cart successfully"
                });
                SET_STORAGE("Bundle", JSON.stringify(cart));
                this.setState({ AddedProducts: cart });
                this.getCart();
                history.push("/create-custom-bundle-by-price")
            }
        }
    };

    // Amount-tier helpers
    computeTierProgress = (discount, subtotal, fallbackThreshold) => {
        const minAmt = discount && discount.min_amount ? parseFloat(discount.min_amount) : null;
        const maxAmt = discount && discount.max_amount ? parseFloat(discount.max_amount) : null;
        if (Number.isFinite(minAmt) && minAmt > 0) {
            if (Number.isFinite(maxAmt) && maxAmt > 0 && maxAmt > minAmt) {
                const clamped = Math.max(0, Math.min(subtotal - minAmt, maxAmt - minAmt));
                return (clamped / (maxAmt - minAmt)) * 100;
            }
            return Math.min(100, (subtotal / minAmt) * 100);
        }
        const threshold = Number.isFinite(fallbackThreshold) ? fallbackThreshold : 0;
        if (threshold <= 0) return 0;
        return Math.min(100, (subtotal / threshold) * 100);
    }

    formatTierLabel = (discount, fallbackThreshold, CURRENCY_FORMAT) => {
        const minAmt = discount && discount.min_amount ? parseFloat(discount.min_amount) : null;
        if (Number.isFinite(minAmt) && minAmt > 0) {
            return `${CURRENCY_FORMAT(minAmt).replace(' USD', '')}+`;
        }
        const threshold = Number.isFinite(fallbackThreshold) ? fallbackThreshold : 0;
        return threshold > 0 ? `${CURRENCY_FORMAT(threshold).replace(' USD', '')}+` : '';
    }

    getTierAmount = (discount) => {
        const raw = (discount && (discount.amount || discount.discount_amount || discount.discount));
        const val = parseFloat(raw);
        return Number.isFinite(val) ? val : 0;
    }

    getCurrentSubtotal = () => {
        const { AddedProducts } = this.state;
        let sum = 0;
        (AddedProducts || []).forEach((p) => {
            const unit = parseFloat(p.cart_sale_price);
            sum += (isNaN(unit) ? 0 : unit) * parseInt(p.quantity, 10);
        });
        return sum.toFixed(2);
    }

    // Subtotal to display on CTA
    getDisplayedSubtotal = () => {
        const { AddedProducts } = this.state;
        let sum = 0;
        (AddedProducts || []).forEach((p) => {
            const price = p.custom_bundle_discount_price !== undefined ? parseFloat(p.custom_bundle_discount_price) : parseFloat(p.cart_sale_price);
            sum += (isNaN(price) ? 0 : price) * parseInt(p.quantity, 10);
        });
        return sum.toFixed(2);
    }

    // Subscription factor helper for per-line prices
    getSubscriptionFactor = () => {
        const { subscription, subscription_detail } = this.state;
        if (subscription === 'yes' && subscription_detail) {
            const pct = parseFloat(subscription_detail.subscription_save_percentage || subscription_detail.subscription_save_percentage_refer || 0);
            if (Number.isFinite(pct) && pct > 0) {
                return (100 - pct) / 100;
            }
        }
        return 1;
    }

    // Get the displayed unit price (discounted if available, otherwise original)
    getDisplayedUnitPrice = (product) => {
        if (!product) return 0;
        // Use the already discounted price if available, otherwise use the regular price
        const price = product.custom_bundle_discount_price !== undefined ? 
                     parseFloat(product.custom_bundle_discount_price) : 
                     parseFloat(product.cart_sale_price);
        return isNaN(price) ? 0 : price;
	}

	updateAddedProducts = (newProduct) => {
		const products = JSON.parse(newProduct);
		let discount_data_new = GET_STORAGE("Discount_data") ? JSON.parse(GET_STORAGE("Discount_data")) : [];
		const isSubscription = GET_STORAGE('is_subscription') === "yes";
		let subscriptionSavePercentage = 0;

		// Get subscription discount if applicable
		if (isSubscription) {
			try {
				const subscription_detail = JSON.parse(GET_STORAGE("CustomSubscriptionDetail") || '{}');
				subscriptionSavePercentage = parseFloat(subscription_detail.subscription_save_percentage_refer || 0);
			} catch (e) {
				console.error("Error parsing subscription details:", e);
			}
		}

		// Apply only one type of discount (either quantity discount or subscription, not both)
		const updatedProducts = products.map((product, index) => {
			let finalPrice = parseFloat(product.cart_sale_price);
			let discount = 0;

			// Apply either quantity discount or subscription discount, whichever is greater
			if (discount_data_new.length > 0 && index < discount_data_new.length) {
				discount = parseFloat(discount_data_new[index]) || 0;
			} else if (isSubscription && subscriptionSavePercentage > 0) {
				discount = finalPrice * (subscriptionSavePercentage / 100);
			}

			// Ensure we don't discount below zero
			discount = Math.min(discount, finalPrice);
			
			return {
				...product,
				custom_bundle_discount_price: (finalPrice - discount).toFixed(2),
				custom_bundle_discount: discount.toFixed(2),
				original_price: finalPrice.toFixed(2) // Store original price for reference
			};
		});

		// Update state and storage
		this.setState({
			AddedProducts: updatedProducts,
			discount_data: discount_data_new,
			NotallowedtoSubscription: products.some(p => (p.subscription_status === "0" || p.subscription_status == null))
		});

		// Update storage
		SET_STORAGE("Bundle", JSON.stringify(updatedProducts));
	}

    render() {
        const addedProducts = this.state.AddedProducts || [];
        const filteredAddedProducts = addedProducts;
        const isAmountBased = this.state.custom_bundle_discount_settings === 'enable';
        const amountTiers = Array.isArray(this.state.order_amount_discount) ? this.state.order_amount_discount.filter(d => d && d.min_amount) : [];
        const sortedAmountTiers = amountTiers.slice().sort((a, b) => parseFloat(a.min_amount) - parseFloat(b.min_amount));
        const currentSubtotal = this.getDisplayedSubtotal();
        return (
            <Fragment>
                {
                    (this.state.loading) ? <div className="loading container full_page_loader"></div> :
                        <Fragment>
                            <div className="suplements_blk custom_bundle_blk p-0">
                                <div className="container-fluid p-0">
                                    <div className="row m-0">
                                        <div className="col-md-8 p-0">
                                            <main className="athletes_list_wrapper custom_bunde_left">
                                                <div className="d-flex align-items-center respons_flex_direction mb_28 justify-content-between">
                                                    <div className="pro_head_blk">
                                                        <h2 className="product_itle text_black let_spa_2 font_24 fw_el_semi mb_6 mobile_hide">Build your own bundle</h2>
                                                        <nav aria-label="breadcrumb" className="m-0 mobile_hide">
                                                            <ol className="breadcrumb cus_breadcrumb pro_breadcrumb">
                                                                <li className="breadcrumb-item"><NavLink to="/"><img src={HomeIcon} alt="home_icon" /></NavLink></li>
                                                                <li className="breadcrumb-item active" aria-current="page">  ~ Supplements ~ Build your Own Bundle</li>
                                                            </ol>
                                                        </nav>
                                                    </div>
                                                    <div className="input_bundle_btn d-flex justify-content-end align-items-center">
                                                        <form className="product-search-form nxt_bundle_btn w-50 m-0 product_search_input position-relative form_input_blk" method="get">
                                                            <div className="search-input-group">
                                                                <input onChange={this.filterProduct} value={this.state.searchName}
                                                                    className="form-control" placeholder="Search" name="searchName" id="filter-by" type="text" />
                                                            </div>
                                                            <div className="search_icon position-absolute d-flex align-items-center justify-content-center">
                                                                <img src={SearchIcon} alt="search icon" />
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                                {/* Progress bar should appear only in the sidebar, not here */}
                                                <div className="row sup_pro_row">
                                                    {this.state.products_filtered.length <= 0
                                                        ? <h3>No Product Matched!</h3>
                                                        : this.state.products_filtered.map(function (product, key) {
                                                            product.quickView = this.quickView;
                                                            return (
                                                                (product.is_bundle == 0 ?
                                                                    <SingleCustomProductListGrid
                                                                        key={Math.random()}
                                                                        product={product}
                                                                        subscription={this.state.subscription}
                                                                        updateAddedProducts={this.updateAddedProducts}
                                                                        toggleSubscription={this.isSubscription}
                                                                    /> : ""
                                                                )
                                                            );
                                                        }.bind(this))}
                                                </div>
                                                {this.state.searchName == '' ?
                                                    <Pagination
                                                        pagenationHandle={this.pagenationHandle}
                                                        total_records={this.state.total_records}
                                                        total_page={this.state.total_page}
                                                        per_page={this.state.per_page}
                                                        pagenum={this.state.pagenum}
                                                    /> : ""
                                                }
                                            </main>
                                        </div>
                                        <div className="col-md-4 p-0 Bundle_Added">
                                            <div className='custom_bunde_left'>
                                                <h2 className="product_itle text_black let_spa_2 font_24 fw_el_semi mb_6 mobile_show">Build your own bundle</h2>
                                                <nav aria-label="breadcrumb" className="mb_20 mobile_show">
                                                    <ol className="breadcrumb cus_breadcrumb pro_breadcrumb">
                                                        <li className="breadcrumb-item"><NavLink to="/"><img src={HomeIcon} alt="home_icon" /></NavLink></li>
                                                        <li className="breadcrumb-item active" aria-current="page">  ~ Supplements ~ Build your Own Bundle </li>
                                                    </ol>
                                                </nav>
                                                <h2 className="font_24 mt-0 mb_15 fw-bold">Your Product Bundle</h2>
                                                {isAmountBased && sortedAmountTiers.length > 0 ? (
                                                    <div className='bundle_progress_bar w-100 mb_22'>
                                                        <ul className='d-flex flex-wrap w-100'>
                                                            {sortedAmountTiers.map((discount, index) => {
                                                                const minAmt = parseFloat(discount.min_amount);
                                                                const thresholdAmount = minAmt;
                                                                const progressPercentage = this.computeTierProgress(discount, currentSubtotal, thresholdAmount);
                                                                const isReached = Number.isFinite(minAmt) && minAmt > 0 ? (currentSubtotal >= minAmt) : false;
                                                                
                                                                const isFreeShippingTier = discount.initial_free_shipping === 1 || 
                                                                                          discount.initial_free_shipping === '1' ||
                                                                                          discount.free_shipping === 1 ||
                                                                                          discount.free_shipping === '1';
                                                                
                                                                const isFreeShippingReached = isFreeShippingTier && isReached;
                                                                
                                                                return (
                                                                    <li key={index} className={`${isReached ? 'prod_added' : ''} ${isFreeShippingReached ? 'free-shipping-tier' : ''}`}>
                                                                        {isFreeShippingReached && (
                                                                            <div className="truck-above-circle" title="Free Shipping">
                                                                                <svg className="truck-icon-above" viewBox="0 0 24 24" fill="currentColor">
                                                                                    <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                                                                                </svg>
                                                                            </div>
                                                                        )}
                                                                        
                                                                        <div className="discount-progress-bar">
                                                                            <div className={`progress-bar ${isFreeShippingReached ? 'free-shipping-progress' : ''}`} 
                                                                                 style={{ width: `${progressPercentage}%` }}></div>
                                                                        </div>
                                                                        
                                                                        <span className={`round_circle d-flex justify-content-center align-items-center font_12 mb_5 mx-auto ${isFreeShippingReached ? 'free-shipping-circle' : ''}`}>
                                                                            ${Math.round(this.getTierAmount(discount)).toLocaleString()}
                                                                        </span>
                                                                        
                                                                        <span className="font_10 text_black d-block text-center">
                                                                            {this.formatTierLabel(discount, thresholdAmount, CURRENCY_FORMAT)}
                                                                        </span>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </div>
                                                ) : null}

                                                <div className='right_bundle_blk'>
                                                    {this.state.AddedProducts?.map(function (product, key) {
                                                        product.deleteItem = this.deleteItem;
                                                        product.row_id = key;
                                                        return (
                                                            <div className={classnames("mb_22 cart_pro_list d-flex align-items-center justify-content-between")} key={product.row_id}>
                                                                <div className="cart_pro_list_left w-100 p-0 d-flex align-items-center">
                                                                    <div className="cart_pro_img">
                                                                        <ReactImageFallback
                                                                            src={product.cart_image}
                                                                            fallbackImage={require('../../Assets/images/preloader.gif')}
                                                                            initialImage={require('../../Assets/images/preloader.gif')}
                                                                            alt=''
                                                                            className="cart_product_img" />
                                                                    </div>
                                                                    <div className="cart_pro_det pl_13">
                                                                        <div className='d-flex align-items-start justify-content-between head_del_blk mb_10'>
                                                                            <h4 className="font_16 text_black let_spa_2 fw_el_bold m-0 line_height_25">{product.cart_product_name}</h4>
                                                                            <div data-title="Remove" className='d-flex'>
                                                                                <a onClick={(e) => product.deleteItem(e, product.row_id)} href="#" className="font_12 d-flex red_text fw_ar_reg"><img src={DeleteIcon} /></a>
                                                                            </div>
                                                                        </div>
                                                                        <div className={`cart_quantity quan_cart_blk w-100 custom_bundle_qty mb_10 ${(product.activeFlavors !== undefined) ? 'quatitywithFla' : ''}`}>
                                                                              {(product.activeFlavors !== undefined) ? (
                                                                                <div className="w-100 side-flavors">
                                                                                    <select onChange={(e) => this.changeFirstMonthFlovour(product, product.productInfo, product.activeFlavors, e.target.value)} name="flovour" className="w-100 select_flavour select_flavour_bundle font_16 let_spa_2 text-black fw_ar_reg" value={product.cart_flavor_id}>
                                                                                        {(product.activeFlavors !== undefined) ?
                                                                                            product.activeFlavors.map(function (flavor, key) {
                                                                                                return (
                                                                                                    <option key={key} value={flavor.hasOwnProperty('id') ? flavor.id : null}>{flavor.hasOwnProperty('value') ? flavor.value : null}</option>
                                                                                                )
                                                                                            }.bind(this)) : null
                                                                                        }
                                                                                    </select>
                                                                                </div>
                                                                            ) : null}
                                                                            </div>
                                                                             <div className='d-flex align-items-start justify-content-between cus_pro_quan_blk'>
                                                                            <div>
                                                                                <h4 className="font_14 m-0 text_black let_spa_2 text-uppercase fw-reg">{CURRENCY_FORMAT(this.getDisplayedUnitPrice(product)).replace(' USD', '')}</h4>
                                                                            </div>
                                                                            <div className="cart_quantity quan_cart_blk custom_bundle_qty m-0 quatitywithFla qty_cus_bun">
                                                                                <div className='qunatity_blk w-100'>
                                                                                    <h5 className="text_opacity font_12 m-0">Qty</h5>
                                                                                    <div data-title="Quantity" className="input-group refer_product_input_group">
                                                                                        <div className="input-group-prepend">
                                                                                            <button type="button" onClick={() => this.quantityDecrement(product.cart_variation_id, product.quantity)} disabled={(product.quantity <= 1) ? "disabled" : ""} className="btn btn-sm"><i className="fa fa-minus"></i></button>
                                                                                        </div>
                                                                                        <input value={product.quantity} readOnly className="text-center font_13 p-0 form-control form-control-sm product_quantity_content refer_product_quantity_content" />
                                                                                        <div className="input-group-prepend">
                                                                                            <button type="button" onClick={() => this.quantityIncrement(product.cart_variation_id, product.quantity)} className="btn btn-sm"><i className="fa fa-plus"></i></button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <h4 className="font_14 m-0 text_black let_spa_2 text-uppercase fw_ar_bold" data-title="total">{CURRENCY_FORMAT(this.getDisplayedUnitPrice(product) * parseInt(product.quantity || 1, 10))}</h4>
                                                                            </div>
                                                                        </div>
                                                                        {(this.state.subscription_detail.is_subscription == 'yes' && (product.subscription_status == '0' || product.subscription_status == null)) && (
                                                                            <span className="d-block items_text font_14 fw_ar_reg mb_9 text_red">
                                                                                {product.cart_variation_name != null
                                                                                    ? `${product.cart_product_name} - ${product.cart_variation_name} is not available for subscription. Please remove from your cart to enable subscribe and save.`
                                                                                    : `${product.cart_product_name} is not available for subscription. Please remove from your cart to enable subscribe and save.`}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    }.bind(this))}
                                                </div>
                                                <div className="product_upload text-center mb_22">
                                                    <img src={UploadIcon} className="mb_15" />
                                                    <h6 className="font_12 m-0 text_opacity text-center">Add Product for your Bundle</h6>
                                                </div>
                                                {(this.state.subscription_detail && this.state.subscription_detail.is_subscription !== 'no') ? (
                                                    <Fragment>
                                                        <label onClick={!this.state.NotallowedtoSubscription ? this.isSubscription : null} className={`w-100 cus_bun_subscri_blk subscri_blk pro_subscri_blk d-flex align-items-center checkbox_label mx-0 mb_22 radio_label ${this.state.NotallowedtoSubscription ? 'disable disabled' : ''}`} htmlFor="purchase_type_subscription" style={this.state.NotallowedtoSubscription ? { opacity: '0.5', cursor: 'not-allowed' } : {}}>
                                                            <div className="sub_lft position-relative">
                                                                <input defaultValue="subscription" name="purchase_type" id="purchase_type_subscription" className="" type="radio" checked={this.state.subscription == "yes"} onChange={this.isSubscription} disabled={this.state.NotallowedtoSubscription} />
                                                                <span className="checbox"></span>
                                                            </div>
                                                            <div className="sub_rgt pl_16">
                                                                <div className="d-flex align-items-center">
                                                                    <h3 className="font_16 text_black let_spa_2 fw_ar_reg m-0">
                                                                        Subscribe and Save {this.state.subscription_detail.subscription_save_percentage || 0}% for 1 month
                                                                    </h3>
                                                                </div>
                                                                {this.state.subscription != 'no' && (
                                                                    <div className="d-flex align-items-center mt_5">
                                                                        <span className="d-block font_14 text_black fw_ar_bold let_spa_2">
                                                                            Order will ship every: 1 Month(s)
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </label>
                                                    </Fragment>
                                                ) : null}
                                                <div>
                                                    <button
                                                        className="shop_more add_cart_btn font_16 banner_text text-center fw_ar_reg add_to_bundle add_bundle_btn"
                                                        onClick={this.alertModel}
                                                        disabled={filteredAddedProducts.reduce((total, item) => total + (item.quantity || 1), 0) < 2}
                                                        style={filteredAddedProducts.reduce((total, item) => total + (item.quantity || 1), 0) < 2 ? { opacity: '0.5', cursor: 'not-allowed' } : {}}>
                                                        Add Bundle to your Cart {CURRENCY_FORMAT(this.getDisplayedSubtotal()).replace(' USD', '')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                }
                {/* Custom bundle product modal start  */}
                <div className="modal fade" id={'alertModel'} tabIndex="-1" role="dialog" aria-labelledby="alertModel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header cus-modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body montserrat">
                                <p className="font_16 text_black fw_ar_reg m-0">
                                    You cannot add a custom bundle product to your cart while a regular product is already in it, You can delete regular product to proceed with the custom bundle product.
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button onClick={(e) => history.push('/cart')} type="button" className="cus_button" data-dismiss="modal">OK</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Custom bundle product modal  */}
            </Fragment>
        );
    }
}

export default CreateCustomBundleByPrice;